import { TransferLoanRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateTransferLoan = (allowTransferDateAnyDayOfMonth: boolean) =>
  makeValidator({
    FieldParser: TransferLoanRow(allowTransferDateAnyDayOfMonth),
  });
